import { useKnowledgeStore } from '@/stores/knowledge';

const DECISION_COLORS: Record<string, string> = {
  merge: 'text-emerald-600 bg-emerald-50',
  link: 'text-blue-600 bg-blue-50',
  distinct: 'text-slate-500 bg-slate-100',
  promote: 'text-violet-600 bg-violet-50',
};

export function ResolutionHistory() {
  const { resolutionHistory, historyLoading } = useKnowledgeStore();

  if (historyLoading) {
    return <div className="text-sm text-slate-400">Loading history...</div>;
  }

  if (resolutionHistory.length === 0) {
    return <div className="text-sm text-slate-400">No resolution history available.</div>;
  }

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold text-slate-700 mb-3">
        Resolution Audit Trail ({resolutionHistory.length} decisions)
      </h3>
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 text-xs">
              <th className="text-left py-2.5 px-3">Decision</th>
              <th className="text-left py-2.5 px-3">Confidence</th>
              <th className="text-left py-2.5 px-3">Sources</th>
              <th className="text-left py-2.5 px-3">Reasoning</th>
              <th className="text-left py-2.5 px-3">Model</th>
              <th className="text-left py-2.5 px-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {resolutionHistory.map((result, i) => (
              <tr key={result.id || i} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                <td className="py-2.5 px-3">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${DECISION_COLORS[result.decision] || 'text-slate-500 bg-slate-100'}`}>
                    {result.decision?.toUpperCase()}
                  </span>
                  {result.action && (
                    <span className="ml-1 text-xs text-slate-400">({result.action})</span>
                  )}
                </td>
                <td className="py-2.5 px-3 text-slate-700 font-medium">
                  {result.confidence ? `${(result.confidence * 100).toFixed(0)}%` : '-'}
                </td>
                <td className="py-2.5 px-3 text-slate-500">
                  {result.source_entity_ids?.length || 0}
                </td>
                <td className="py-2.5 px-3 text-slate-500 max-w-xs truncate" title={result.reasoning}>
                  {result.reasoning || '-'}
                </td>
                <td className="py-2.5 px-3 text-slate-400 text-xs">
                  {result.model_used || '-'}
                </td>
                <td className="py-2.5 px-3 text-slate-400 text-xs whitespace-nowrap">
                  {result.created_at ? new Date(result.created_at).toLocaleDateString() : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
